enum AppEnvironmentEnum {
    PRODUCTION = "production",
    STAGING = "staging",
    STAGING2 = "staging2",
    LOCAL = "local",
}

export default AppEnvironmentEnum;
